import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subject} from 'rxjs';
import {select, Store} from '@ngrx/store';
import {IWorkflowCollectionState} from '../../../../workflow/store/workflow.reducer';
import {ParticleService} from '@core/services/particle.service';
import {Router} from '@angular/router';
import {Guid} from 'guid-typescript';
import {getWorkflowReducerState, isWorkflowCleanedUp} from '../../../../workflow/store/workflow.selector';
import {catchError, takeUntil} from 'rxjs/operators';
import {Configuration} from '@shared/models/configuration';
import {CreateWorkflowAction} from '../../../../workflow/store/workflow.actions';
import {CommandService} from '@core/services/command.service';
import {
  SyncIntermediariesCommand, SyncOtherPersonsCommand,
  SyncRelevantTaxpayersCommand
} from '../../../commands/dac6-reporter.command';
import {GetFieldSectionsAction} from '@shared/store/actions/virtual-grid.actions';
import {BasketProvider} from "@shared/models/basket-provider";
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';

@Component({
    standalone: false,
    selector: 'particle-participants-manage-entities',
  templateUrl: './participants-manage-entities.component.html',
  styleUrls: ['./participants-manage-entities.component.scss']
})
export class ParticipantsManageEntitiesComponent implements OnInit, OnDestroy {

  workflowTemplate: string;
  apiEndpointKey: string;
  workflowState$: any;
  cleanedUp$: any;
  unsubscribe$ = new Subject<void>();
  hasWorkflowId = false;
  workflowId: string;
  reRouteUrl: string;
  workFlowName: string;
  entitySelectorFilterId: string = null;
  commandExecuted = false;
  sourceType = null;
  constructor(private store: Store<IWorkflowCollectionState>,
              private particleService: ParticleService,
              private fuseSplashScreenService: FuseSplashScreenService,
              private router: Router,
              protected commandService: CommandService) {
    this.workflowId = Guid.create().toString();
    this.apiEndpointKey = 'Dac6Api';
    this.init();
  }
  init() {
    if (this.router.url.toLowerCase().includes('relevant-taxpayers')) {
      this.workflowTemplate = 'dac6-relevant-taxpayers-manage-entities-ui-workflow';
      this.reRouteUrl = 'dac6-reporter/participants/relevant-taxpayers';
      this.workFlowName = 'Dac6 Relevant Taxpayers Manage Entities ui Workflow';
      this.sourceType = 'Relevant-Taxpayers';
    } else if (this.router.url.toLowerCase().includes('intermediaries')) {
      this.workflowTemplate = 'dac6-intermediaries-manage-entities-ui-workflow';
      this.reRouteUrl = 'dac6-reporter/participants/intermediaries';
      this.workFlowName = 'Dac6 Intermediaries Manage Entities ui Workflow';
      this.sourceType = 'Intermediaries';
    } else if (this.router.url.toLowerCase().includes('other-persons')) {
      this.workflowTemplate = 'dac6-other-persons-manage-entities-ui-workflow';
      this.reRouteUrl = 'dac6-reporter/participants/other-persons';
      this.workFlowName = 'Dac6 Other Persons Manage Entities ui Workflow';
      this.sourceType = 'Other-Persons';
    }
  }
  ngOnInit() {
    const currentBasket = BasketProvider.getCurrentBasket();
    this.workflowTemplate = this.workflowTemplate + currentBasket.basketKey;
    this.workflowState$ = this.store.pipe(select(getWorkflowReducerState, this.workflowId));
    this.workflowState$.pipe(takeUntil(this.unsubscribe$)).subscribe(state => {
      if (state) {
        console.log('workflow', state);
        const manageEntitiesState = state.states.find(s => s.Id === 'manage-entities');
        if (manageEntitiesState) {
          const filterIdInput =  manageEntitiesState.Inputs.find(i => i.Name == 'FilterId');
          this.entitySelectorFilterId = filterIdInput ? filterIdInput.Value : null;
        }
        this.cleanWorkflow();
      }

    });

    const url = `${Configuration.getConfig(this.apiEndpointKey)}Command/CreateWorkflow`;
    const action = new CreateWorkflowAction(url, this.workflowId , this.workFlowName, this.workflowTemplate);
    this.store.dispatch(action);
  }
  cleanWorkflow() {
    this.fuseSplashScreenService.show();
    this.cleanedUp$ = this.store.pipe(select(isWorkflowCleanedUp, this.workflowId));
    this.cleanedUp$.pipe(takeUntil(this.unsubscribe$)).pipe(takeUntil(this.unsubscribe$)).subscribe(state => {
      if (state === 'Finished' && !this.commandExecuted) {
        this.commandExecuted = true;
        let command = null;
        if (this.router.url.toLowerCase().includes('relevant-taxpayers')) {
          command = new SyncRelevantTaxpayersCommand(this.entitySelectorFilterId);
        } else if (this.router.url.toLowerCase().includes('intermediaries')) {
          command = new SyncIntermediariesCommand(this.entitySelectorFilterId);
        } else if (this.router.url.toLowerCase().includes('other-persons')) {
          command = new SyncOtherPersonsCommand(this.entitySelectorFilterId);
        }

        this.commandService.executeCommand(command).pipe().subscribe(commandState => {
          this.fuseSplashScreenService.hide();
          if (commandState) {
            this.store.dispatch(new GetFieldSectionsAction(this.sourceType));
            this.router.navigateByUrl(this.reRouteUrl);
          }
        }, error => {
          console.log(error);
          this.fuseSplashScreenService.hide();
          return this.router.navigateByUrl(this.reRouteUrl)
        });
      } else if (state === 'Cancelled') {
        this.fuseSplashScreenService.hide();
        this.router.navigateByUrl(this.reRouteUrl);
      }
    });
  }
  onGridCellValueChange($event) {
    console.log('cell value change', $event);
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
